import React from 'react'
import { withData } from '../withData'
import { compose } from 'recompose'
import _ from 'lodash'
import { PatientCard } from '../Card/PatientCard'
import {Helmet} from 'react-helmet'
import { graphql } from '../graphql'
import qs from 'query-string'
import './PatientList.scss'
import { Link } from 'react-router-dom'
import {
  Modal,
  Icon
} from 'antd'

const confirm = Modal.confirm

const q = `
  query {
    patients() {
      displayName,
      displayImage,
      patient {
        id,
        firstname,
        lastname
      }
    }
  }
`

const enhance = compose(
  withData(q)
)

const removePrompt = (e, _patient, data, setData) => {
  e.stopPropagation()
  e.preventDefault()
  console.log('removing', _patient)
  const { patient } = _patient
  const patientId = patient.id
  confirm({
    title: `จะลบผู้ป่วย ${patient.firstname} ${patient.lastname} หรือไม่?`,
    content: 'หากลบแล้วจะไม่มีการแจ้งเตือนเกี่ยวกับผู้ป่วยท่านนี้อีก',
    okText: 'ลบผู้ป่วย',
    cancelText: 'ยกเลิก',
    onOk: () => {
      const deleteMutation = `
        mutation {
          removePatient(
            patientId: "${patientId}"
          ) {
            success
          }
        }
      `
      graphql(deleteMutation).then((response) => {
        console.log(response)
        if (_.get(response, 'data.removePatient.success')) {
          setData({
            data: {
              patients: _.reject(data.data.patients, (patientObject) => {
                console.log('patient:', patientObject)
                return patientObject.patient.id === patientId
              })
            }
          })
        }
      })
    },
    onCancel: () => {
      console.log('Cancelled')
    }
  })
}

const renderPatients = (patients = [], data, setData) => {
  if ((patients || []).length > 0) {
    const token = qs.parse(location.hash.split('?').pop()).token || localStorage.getItem('token')
    return _.map(patients, (patient, index) => {
      console.log('patient:', patient)
      return (
        <div className="patient" key={index}>
          <Link to={`/patients/${_.get(patient, 'patient.id')}/menu?token=${token}`}>
            <PatientCard userInfo={patient} isCaringPatient />
            <Icon className="delete-button-icon" type="close-circle-o" onClick={(e) => removePrompt(e, patient, data, setData)} />
          </Link>
        </div>
      )
    })
  }
  return <div className="patients-empty">ยังไม่มีผู้ป่วยในการดูแล</div>
}

const PatientList = ({ data, setData }) => {
  console.log('data:', data)
  const patients = _.get(data, 'data.patients') || []
  return (
    <div className="patients">
      <Helmet>
        <title>รายชื่อผู้ป่วยในการดูแลของคุณ</title>
      </Helmet>
      <h2>
        <center>รายชื่อผู้ป่วยในการดูแลของคุณ</center>
      </h2>
      {renderPatients(patients, data, setData)}
    </div>
  )
}

export default enhance(PatientList)



// WEBPACK FOOTER //
// ./src/PatientList/PatientList.js